import React, {Component} from 'react';
import Logo from '../img/flitsmeister_full_light.png';
import LogoTouring from '../img/icon-touring.png';
import Appstore from '../img/appstore.png';
import GooglePlay from '../img/googleplay.png';
import './EtaInfo.css';

class EtaInfo extends Component {
    render() {
        let logo;
        let moreInfoText;
        let websiteLink;
        let websiteLinkMobile;
        let playStoreLink;
        let appStoreLink;

        let favicon = document.querySelector("link[rel*='icon']") || document.createElement('link');
        favicon.type = 'image/x-icon';
        favicon.rel = 'shortcut icon';

        switch (this.props.host) {
            case "flitsmeister":
                favicon.href = '/flitsmeister_app_icon.ico';
                document.title = "Flitsmeister - ETA tracking";

                logo = <div className='fm-logo'><img src={Logo} alt='FM logo'/></div>;
                moreInfoText =
                    <p>Gebruik Flitsmeister samen met meer dan 2,8 miljoen andere automobilisten en zit nooit meer
                        gefrustreerd achter het stuur.</p>;
                websiteLink = <a href='http://www.flitsmeister.nl' target='_blank'
                                 rel='noopener noreferrer'>www.flitsmeister.nl</a>;
                websiteLinkMobile =
                    <a href='http://www.flitsmeister.nl' target='_blank' rel='noopener noreferrer'>MEER INFO</a>;
                appStoreLink = "https://itunes.apple.com/nl/app/flitsmeister/id354936286?mt=8";
                playStoreLink = "https://play.google.com/store/apps/details?id=nl.flitsmeister";
                break;
            case "touring":
                favicon.href = '/touring.ico';
                document.title = "Touring Mobilis - ETA tracking";

                logo = <div className='logo-container'><img src={LogoTouring} alt='Touring Mobilis logo'
                                                            className="logo-img"/></div>;
                websiteLinkMobile =
                    <a href='http://www.touringmobilis.be/' target='_blank' rel='noopener noreferrer'
                       style={{color: "#131D5E"}}>MEER INFO</a>;
                appStoreLink = "https://itunes.apple.com/nl/app/touring-mobilis-verkeer-gps/id647810329?mt=8";
                playStoreLink = "https://play.google.com/store/apps/details?id=be.bemobile.touringmobilis";
                break;
            default:
                favicon.href = '/flitsmeister_app_icon.ico';
                document.title = "Flitsmeister - ETA tracking";

                logo = <div className='fm-logo'><img src={Logo} alt='FM logo'/></div>;
                moreInfoText =
                    <p>Gebruik Flitsmeister samen met meer dan 2 miljoen andere automobilisten en zit nooit meer
                        gefrustreerd achter het stuur.</p>;
                websiteLink = <a href='http://www.flitsmeister.nl' target='_blank'
                                 rel='noopener noreferrer'>www.flitsmeister.nl</a>;
                websiteLinkMobile =
                    <a href='http://www.flitsmeister.nl' target='_blank' rel='noopener noreferrer'>MEER INFO</a>;
                appStoreLink = "https://itunes.apple.com/nl/app/flitsmeister/id354936286?mt=8";
                playStoreLink = "https://play.google.com/store/apps/details?id=nl.flitsmeister";
                break;
        }

        document.getElementsByTagName('head')[0].appendChild(favicon);


        return (
            <div className={this.props.landscape ? 'EtaInfo EtaInfoLandscape' : 'EtaInfo'}>
                {logo}
                <div className='meer-info'>
                    {websiteLinkMobile}
                </div>
                <div className='info-en-stores'>
                    {moreInfoText}
                    <div className='app-buttons'>
                        <div style={{marginBottom: "2%"}}>
                            <a href={appStoreLink} target='_blank'
                               rel='noopener noreferrer'>
                                <img src={Appstore}
                                     alt='Available on the App Store'/></a>
                        </div>
                        <a href={playStoreLink} target='_blank'
                           rel='noopener noreferrer'>
                            <img src={GooglePlay}
                                 alt='Available on the Google Play'/>
                        </a>
                    </div>
                    {this.props.host === "touring" ? null : <div className='meer-info-desktop'>Ga voor meer info naar</div>}
                    {websiteLink}
                </div>
            </div>
        );
    }
}

export default EtaInfo;
